function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m473.771 0h-394.112c-21.069 0-38.149 17.08-38.149 38.149v394.271c0 21.069 17.08 38.149 38.149 38.149h394.112c21.069 0 38.149-17.08 38.149-38.149v-394.271c.001-21.069-17.079-38.149-38.149-38.149z",
  fill: "#eb392e"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m432.341 41.43h-394.112c-21.069 0-38.149 17.08-38.149 38.149v394.271c-.001 21.07 17.079 38.15 38.149 38.15h394.112c21.069 0 38.149-17.08 38.149-38.149v-394.271c0-21.07-17.08-38.15-38.149-38.15z",
  fill: "#eaf2ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m432.341 41.43h-58.233c21.069 0 38.15 17.08 38.15 38.149v394.271c0 21.069-17.08 38.15-38.15 38.15h58.233c21.069 0 38.15-17.08 38.15-38.15v-394.27c-.001-21.07-17.081-38.15-38.15-38.15z",
  fill: "#c9e0fd"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m71.825 453.767c-7.451 0-13.512-6.061-13.512-13.512v-327.08c0-7.451 6.061-13.512 13.512-13.512h326.921c7.451 0 13.512 6.061 13.512 13.512v327.08c0 7.451-6.061 13.512-13.512 13.512z",
  fill: "#fcf7e0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m398.745 99.663h-57.257c7.451 0 13.512 6.062 13.512 13.512v327.08c0 7.451-6.061 13.512-13.512 13.512h57.257c7.451 0 13.512-6.061 13.512-13.512v-327.08c0-7.451-6.061-13.512-13.512-13.512z",
  fill: "#f7ecad"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m71.047 280.04c-4.269 0-8.509.064-12.735.157v160.059c0 7.451 6.061 13.512 13.512 13.512h308.255c.334-3.111.526-6.242.526-9.397 0-90.758-138.593-164.331-309.558-164.331z",
  fill: "#b3e59f"
}), /*#__PURE__*/React.createElement("path", {
  d: "m353.65 327.791c-115.608 0-213.336 53.052-245.422 125.976h290.517c7.451 0 13.512-6.061 13.512-13.512v-107.771c-18.825-3.056-38.438-4.693-58.607-4.693z",
  fill: "#95d6a4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m355 327.805v112.45c0 7.451-6.061 13.512-13.512 13.512h57.257c7.451 0 13.512-6.061 13.512-13.512v-107.771c-18.404-2.988-37.564-4.608-57.257-4.679z",
  fill: "#78c2a4"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 341.489,
  cy: 183.113,
  fill: "#ffd064",
  r: 35.577
}))), /*#__PURE__*/React.createElement("path", {
  d: "m355 150.199v65.828c12.946-5.32 22.065-18.05 22.065-32.914s-9.119-27.593-22.065-32.914z",
  fill: "#ffc250"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m244.526 192.307h-29.728c-5.464 0-10.523-2.975-13.204-7.764-.76-1.357-1.71-2.611-2.823-3.724-2.716-2.716-6.167-4.398-9.978-4.865-2.196-.268-4.161-1.493-5.369-3.346-4.49-6.885-12.064-10.996-20.259-10.996s-15.769 4.111-20.258 10.995c-1.209 1.853-3.173 3.078-5.369 3.347-3.812.467-7.262 2.149-9.977 4.864-1.114 1.115-2.065 2.368-2.824 3.725-2.681 4.789-7.74 7.764-13.204 7.764-4.141 0-7.498-3.357-7.498-7.498s3.357-7.498 7.498-7.498c.049 0 .094-.048.119-.093 1.433-2.559 3.218-4.915 5.305-7.003 4.283-4.283 9.538-7.199 15.351-8.545 7.402-9.484 18.706-15.053 30.858-15.053s23.456 5.57 30.858 15.053c5.814 1.346 11.068 4.262 15.352 8.545 2.087 2.087 3.872 4.443 5.305 7.003.032.057.079.093.119.093h29.728c4.141 0 7.498 3.357 7.498 7.498s-3.36 7.498-7.5 7.498z",
  fill: "#9bc4f9"
})))));

var SvgGalleryicon = function SvgGalleryicon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGalleryicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/galleryicon.fb6eeafd.svg";
export { ForwardRef as ReactComponent };